/*
 * Saved page renderer (Step 5d).
 * Reads Wishlist.getItems() -> [{id, url}], fetches each product's card
 * via the Section Rendering API (?section_id=wishlist-item), and injects
 * the cards into the grid. Renders progressively as each fetch resolves.
 */
(function () {
  'use strict';

  function init() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var loading = document.querySelector('[data-wishlist-loading]');

    var items = (window.Wishlist && window.Wishlist.getItems) ? window.Wishlist.getItems() : [];
    // localStorage is attacker-influenced: accept only same-origin relative
    // paths ("/..."), rejecting absolute URLs ("scheme:") and
    // protocol-relative URLs ("//host") before fetching.
    var withUrl = items.filter(function (it) {
      if (!it.url || typeof it.url !== 'string') return false;
      if (/^[a-z]+:/i.test(it.url) || /^\/\//.test(it.url)) return false;
      return it.url.charAt(0) === '/';
    });

    if (!withUrl.length) {
      if (empty) empty.hidden = false;
      return;
    }

    if (loading) loading.hidden = false;

    var remaining = withUrl.length;
    function done() {
      remaining -= 1;
      if (remaining <= 0 && loading) loading.hidden = true;
      if (!grid.children.length && empty) empty.hidden = false;
    }

    withUrl.forEach(function (item) {
      var sep = item.url.indexOf('?') === -1 ? '?' : '&';
      fetch(item.url + sep + 'section_id=wishlist-item', { headers: { 'Accept': 'text/html' } })
        .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-wishlist-item]');
          if (card) {
            var li = document.createElement('li');
            li.className = 'grid__item';
            li.setAttribute('data-wishlist-li', item.id);
            li.appendChild(card);
            grid.appendChild(li);
            // Bind the injected heart so it inits red (aria-pressed) and is tappable.
            // wishlist-card.js listens for shopify:section:load and binds e.target.
            li.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: {} }));
          }
          done();
        })
        .catch(function () { done(); });
    });
  }

  // When an item is un-saved (heart tapped on a card), remove its <li> live.
  document.addEventListener('wishlist:changed', function () {
    if (!window.Wishlist) return;
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var lis = grid.querySelectorAll('[data-wishlist-li]');
    for (var i = 0; i < lis.length; i++) {
      var id = lis[i].getAttribute('data-wishlist-li');
      if (!window.Wishlist.has(id)) {
        lis[i].parentNode.removeChild(lis[i]);
      }
    }
    // If the grid is now empty, show the empty state.
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid.children.length && empty) empty.hidden = false;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
